// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    overflow-x: auto;
    white-space: nowrap;
    position: relative;
  }
  
  .table-container table {
    min-width: 100%;
  }
  
  .table-container th:first-child,
  .table-container td:first-child {
    position: sticky;
    left: 0;
    background: white; /* Ensure the background matches the table's background */
    z-index: 2; /* Ensure it stays above other columns */
    min-width: 150px;
    width: 180px;
  }
  /* rest of the td children and th children will have a min-width of 120px */
    .table-container th,
    .table-container td {
      min-width: 160px;
    }

    @media screen and (max-width: 600px) {
      /* on the smallest view port, the result grid can't show a single column, until the variety name is reduced, then all bars can be viewed */
      .table-container [data-column="varietyName"] {
          width: 80px !important;
          min-width: 80px !important;
          text-wrap: auto;
      }
    }`, "",{"version":3,"sources":["webpack://./src/components/result/result-table.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,OAAO;IACP,iBAAiB,EAAE,yDAAyD;IAC5E,UAAU,EAAE,wCAAwC;IACpD,gBAAgB;IAChB,YAAY;EACd;EACA,2EAA2E;IACzE;;MAEE,gBAAgB;IAClB;;IAEA;MACE,0IAA0I;MAC1I;UACI,sBAAsB;UACtB,0BAA0B;UAC1B,eAAe;MACnB;IACF","sourcesContent":[".table-container {\n    overflow-x: auto;\n    white-space: nowrap;\n    position: relative;\n  }\n  \n  .table-container table {\n    min-width: 100%;\n  }\n  \n  .table-container th:first-child,\n  .table-container td:first-child {\n    position: sticky;\n    left: 0;\n    background: white; /* Ensure the background matches the table's background */\n    z-index: 2; /* Ensure it stays above other columns */\n    min-width: 150px;\n    width: 180px;\n  }\n  /* rest of the td children and th children will have a min-width of 120px */\n    .table-container th,\n    .table-container td {\n      min-width: 160px;\n    }\n\n    @media screen and (max-width: 600px) {\n      /* on the smallest view port, the result grid can't show a single column, until the variety name is reduced, then all bars can be viewed */\n      .table-container [data-column=\"varietyName\"] {\n          width: 80px !important;\n          min-width: 80px !important;\n          text-wrap: auto;\n      }\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
